<template>
  <div>
    <progress-loading
        v-model="isLoading"
        :can-cancel="false"
        :is-full-page="true"
        :progress="progress"
        :message="message"
        :message-bottom="messageBottom"
    ></progress-loading>
  </div>
</template>

<script>
import JSZip from "jszip";
import ProgressLoading from "@/components/progress-loading/progress-loading.vue";

const FileSaver = require('file-saver')
export default {
  name: "download-file",
  components: {ProgressLoading},
  props: {},
  data() {
    return {
      isLoading: false,
      progress: 0,
      message: '',
      messageBottom: ''
    }
  },
  methods: {
    async downloadFiles(files, zipName) {
      console.log('Files:', files)

      this.isLoading = true
      this.progress = 0
      this.messageBottom = ''

      if (files.length > 1) {
        //Zip files
        const zip = new JSZip();

        let errorExists = false
        let filesCount = files.length
        let downloading = 0
        for (let file of files) {
          let dataIn = {
            url: file.url,
            callback: this.requestCallback
          }
          this.message = `Downloading file:\n ${file.name}`
          downloading += 1
          this.messageBottom = `${downloading} of ${filesCount}`
          let data = await this.$store.dispatch('downloadFile', dataIn)
          if(data instanceof Error){
            this.showToast(data.message, 'is-danger')
            errorExists = true
          }else{
            let fileType = this.findFileType(file.path)
            let ext = this.findExtension(file.path)
            if(!fileType){
              fileType = this.findFileType(file.name)
            }
            if(!ext){
              ext = this.findExtension(file.name)
            }
            const blob = new Blob([data], {type: fileType})
            if(file.path){
              if(file.path.endsWith(ext)){
                zip.file(file.path, blob)
              }else{
                let path = file.path.substring(0, file.path.lastIndexOf('/'));
                path += `/${file.name}`
                console.log('Path is: ', path)
                zip.file(path, blob)
              }
            }else{
              zip.file(file.name, blob)
            }

          }
        }

        this.message = `Packaging files`
        if(errorExists === false){
          zip.generateAsync({type: "blob"}).then(content => {
            // see FileSaver.js
            FileSaver.saveAs(content, `${zipName}.zip`);
            this.message = `Done`
            setTimeout(()=>{
              this.isLoading = false
            }, 500)
          });
        }else{
          this.isLoading = false
          this.message = `Error detected`
        }

      } else {
        let dataIn = {
          url: files[0].url,
          callback: this.requestCallback
        }
        this.message = `Downloading file: \n ${files[0].name}`
        let data = await this.$store.dispatch('downloadFile', dataIn)

        if(data instanceof Error){
          this.showToast(data.message, 'is-danger')
          this.isLoading = false
        }else{
          let fileType = this.findFileType(files[0].name)
          const blob = new Blob([data], {type: fileType})
          FileSaver.saveAs(blob, files[0].name);
          this.message = `Done`
          this.isLoading = false
        }
      }

    },
    findFileType(pathString){
      if(!pathString){
        return null
      }
      if(pathString.endsWith('.csv')){
        return "text/csv;charset=utf-8;"
      }else if(pathString.endsWith('.jpg') || pathString.endsWith('.jpeg')){
        return 'image/jpeg'
      }else if(pathString.endsWith('.mp4')){
        return 'video/mp4'
      }

      return null
    },
    findExtension(pathString){
      if(!pathString){
        return null
      }
      if(pathString.endsWith('.csv')){
        return ".csv"
      }else if(pathString.endsWith('.jpg') || pathString.endsWith('.jpeg')){
        return '.jpg'
      }else if(pathString.endsWith('.mp4')){
        return '.mp4'
      }

      return null
    },
    requestCallback(percentage) {
      console.log('Callback percentage:', percentage)
      this.progress = percentage
    },
    onDownloadClicked() {
      this.$emit('onDownloadClicked')
    },
    showToast(message, type) {
      this.$buefy.toast.open({
        message: message,
        duration: 3000,
        type: type
      })
    },
  }
}
</script>

<style scoped>

</style>